import React from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import TagManager from 'react-gtm-module';

import './App.scss';
import Main from './Main';
import BackOffice from './backoffice/BackOffice';


const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID,
    dataLayerName: 'PageDataLayer'
}
TagManager.initialize(tagManagerArgs);

if (process.env.REACT_APP_SENTRY_AUTH !== '') {
  window.Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_AUTH,
    release: 'adscontribapp@' + process.env.REACT_APP_RELEASE
  });
}

export default function App() {
  return (
    <Router basename={process.env.REACT_APP_BASENAME || ''}>
      <Switch>
        <Route path="/backoffice">
          <BackOffice/>
        </Route>
        <Route
          render={({ location }) => (
            <Main location={location}/>
          )}
        />
      </Switch>
    </Router>
  );
}
